export const DARK_MODE_FLAG_CACHE_KEY = "fp_dark_mode_flag";

// Logged-out pages never load account metadata, so a cache left behind by a
// signed-out user would decide the theme for the next user on this browser.
export function clearDarkModeFlagCache(): void {
  localStorage.removeItem(DARK_MODE_FLAG_CACHE_KEY);
}
